'use strict';

import Alpine from 'shared/js/alpinejs';

let storage = Alpine.reactive({ translations: {} }); /* eslint-disable-line no-unused-vars */

export default storage;
